module.exports = __webpack_public_path__ + "files/e4713444592e5fd3f685ac695df0bb38.png";